var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"custom-navbar"},[_c('img',{staticClass:"d-inline-block align-top",staticStyle:{"margin-left":"1%"},attrs:{"src":_vm.logoSrc || _vm.fallbackLogo,"width":"300","alt":"Company Logo"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }